module.exports = __webpack_public_path__ + "static/media/proxxmu-hifi1.f0c6f149.png";